<template>
  <div class="container" v-if="product !== null && !loading">
    <form class="section">
      <b-field label="Name">
        <b-input v-model.trim="product.name" name="name" placeholder="Name"></b-input>
      </b-field>
      <b-field label="Description">
        <froala :content="product" :height="250" v-if="(!editing || product.content.length > 0) && upload_code !== null" :upload_code="upload_code" :buttons="['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript',
                    '|', 'fontFamily', 'fontSize', 'color',
                    '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote',
                    'insertTable',
                    '|', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting',
                    '|', 'print', 'help', 'html', '|', 'undo', 'redo']"></froala>
      </b-field>
      <b-field label="Price (in cents)">
        <b-field>
          <b-input type="number" name="price" v-model.number="product.price" expanded></b-input>
          <p class="control">
            <span class="button is-static">${{ (product.price / 100).toFixed(2) }}</span>
          </p>
        </b-field>
      </b-field>
      <b-field>
        <b-checkbox v-model="product.in_stock">In Stock</b-checkbox>
      </b-field>
      <b-field label="Categories">
        <category-select-dropdown v-if="product !== null" :selection="product.categories" @selection="onCategorySelect"></category-select-dropdown>
      </b-field>
      <b-field label="Image">
        <image-upload :imageid="product !== null ? product.imageId : null" @uploaded="onUpload"></image-upload>
      </b-field>
      <button type="button" class="button" @click="$router.push('/admin')">Cancel</button>
      <button type="button" class="button" @click="save">{{ editing? 'Save' : 'Create' }}</button>
    </form>
  </div>
  <loader v-else></loader>
</template>

<script>
import Froala from './FroalaTmp';
import ImageUpload from './ImageUpload';
import CategorySelectDropdown from './CategorySelectDropdown';
import Loader from '../Loader';
import BField from 'buefy/src/components/field/Field';
import BInput from 'buefy/src/components/input/Input';
import BCheckbox from 'buefy/src/components/checkbox/Checkbox';
import BTaginput from 'buefy/src/components/taginput/Taginput';
import BUpload from 'buefy/src/components/upload/Upload';

export default {
  components: {
    BUpload,
    BTaginput,
    BCheckbox,
    BInput,
    BField,
    Loader,
    CategorySelectDropdown,
    ImageUpload,
    Froala,
  },

  name: 'admin-product-form',

  data() {
    return {
      product: null,
      images: [],
    };
  },

  watch: {
    images() {
      // console.log(this.images);
    },
  },

  created() {
    if (this.$route.name === 'AdminProductEdit') {
      this.$store.dispatch('adminProduct/load', this.$route.params.id).then((product) => (this.product = product));
    } else {
      this.product = {
        name: '',
        content: '',
        price: 0,
        in_stock: true,
        categories: [],
        imageId: null,
      };
    }
  },

  methods: {
    save() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.$store.dispatch('adminProduct/save', this.product).then(() => this.$router.push('/admin/3'));
        }
      });
    },

    delete() {
      this.$refs.confModal.show().then((confirmed) => {
        if (confirmed) {
          this.$store.dispatch('adminProduct/delete').then(() => this.$router.replace('/admin/3'));
        }
      });
    },

    onCategorySelect(data) {
      this.product.categories = data;
    },

    onUpload(id) {
      this.product.imageId = id;
    },
  },

  computed: {
    editing() {
      return this.$route.name === 'AdminProductEdit';
    },

    loading() {
      return this.$store.state.adminProduct.loading;
    },

    upload_code() {
      return this.$store.state.image.upload_code;
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/AdminProductForm.vue